export default {
  zh: {
    label: '字段标签',
    api: '字段 API',
    helpText: '提示',
    description: '描述',
    length: '长度',
    scale: '小数点位数',
    nameDuplicate: 'API 重复, 订正为{value}',
    notNullTip1: '必须字段',
    notNullTip2: '一旦勾选，该字段必须存在所有的Page Layout',
    pageLaoyoutName: '布局名',
    department: '部门',
    addNewValue: '添加新的值',
    mapFrom: '映射自{field}',
    mapTo: '映射到{field}',
    pageTitle: '{type}字段',
    defaultFields: '默认{type}字段',
    cstmFields: '自定义{type}字段',
    dataType: '字段类型',
    createField: '创建{type}类型字段',
    addingPagelayoutToDepartment: '将字段添加到Page Layout',
    picklistValue: 'Picklist取值',
    selectValueToReplace: '请选择一个值替换',
    editField: '编辑字段',
    values: '取值',
    deactiveValues: '未激活的取值',
    value: '取值',
    goEffectIn5: '更改将会在5分钟之后生效',
    mustChooseField: '必须选择一个字段',
    updateExistingValue: '更新已有取值',
    restriction: '限制',
    restrictionInfo: '限制以下部门和用户查看该取值',
    doubleClickDepart: '双击添加部门',
    doubleClickUser: '双击添加用户',
    deletePicklistError: '最后一个取值，不能删除',
    lengthErrorMessage: '输入必须为整数',
    action: '操作',
    default: '默认',
    required: '必须字段',
    backToFieldList: '回到字段列表',
    view: '预览',
    restrictionTitle: '{titleLabel} 限制',
    selectAll: '选择全部',
    selectNone: '取消全部',
  },
  en: {
    label: 'Field Label',
    api: 'Field API',
    helpText: 'Help Text',
    description: 'Description',
    length: 'Length',
    scale: 'Decimal Places',
    nameDuplicate: 'API duplicate, modify to {value}',
    notNullTip1: 'Always require value in order to save',
    notNullTip2: 'Once ticked, will show on all page layout',
    pageLaoyoutName: 'Page Layout Name',
    department: 'Departments',
    addNewValue: 'Add New Value',
    mapFrom: 'Map From {field}',
    mapTo: 'Map To {field}',
    pageTitle: '{type} Fields',
    defaultFields: 'Default {type} Fields',
    cstmFields: 'Customized {type} Fields',
    dataType: 'Data Type',
    createField: 'Create New {type}',
    addingPagelayoutToDepartment: 'Adding field to particular page layout',
    picklistValue: 'Picklist Values',
    selectValueToReplace: 'Please select a value to replace ',
    editField: 'Edit Field',
    values: 'Values',
    deactiveValues: 'Deactive Values',
    value: 'Value',
    goEffectIn5: 'Change can take up to 5 mins to become effective.',
    mustChooseField: 'Must choose one field',
    updateExistingValue: 'Updating Existing Value',
    restriction: 'Restriction',
    restrictionInfo: 'Restrict departments or users from viewing this value',
    doubleClickDepart: 'Double click to add department to restriction',
    doubleClickUser: 'Double click to add user to restriction',
    deletePicklistError: 'Can\'t delete the last value',
    lengthErrorMessage: 'Value must be integer',
    action: 'Action',
    default: 'Default',
    required: 'Required Value',
    backToFieldList: 'Back To Field List',
    view: 'View',
    restrictionTitle: '{titleLabel} Restriction',
    selectAll: 'Select All',
    selectNone: 'Select None',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/Fields/i18n.js